import { Checkbox as CheckboxUI } from '@/components/ui/checkbox'
import { cn } from '@/lib/utils'

import type { ReactNode } from 'react'

export const Checkbox = ({
  id,
  name,
  label,
  disabled,
  checked,
  className,
  onChange,
}: {
  id: string
  name?: string
  label?: ReactNode
  className?: string
  disabled?: boolean
  checked?: boolean
  onChange?: (e: boolean) => void
}) => {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <div>
        <CheckboxUI
          onCheckedChange={onChange}
          id={id}
          name={name}
          disabled={disabled}
          checked={checked}
          className={cn(disabled && 'data-[state=checked]:bg-grey-100 data-[state=checked]:text-grey-400 ')}
        />
      </div>
      {label && (
        <label className={cn('text-base text-grey-700', disabled && 'text-grey-400')} htmlFor={id}>
          {label}
        </label>
      )}
    </div>
  )
}
